import React, { useEffect, useState, useRef } from "react";
import { AppHelper } from '../AppHelper';
import {
  Button, Box, ButtonGroup, Chip, Dialog, DialogTitle, Grid, CircularProgress
} from '@mui/material';
import dayjs from "dayjs";
const relativeTime = require("dayjs/plugin/relativeTime");
const configJson = require('../config.json?v=20230925');
dayjs.extend(relativeTime);

export default function PopAccessRights ({
  onClose, open, profile, tuiton
}){
  const [isLoading, setIsLoading] = useState(false);
  const [oUser, setOUser] = useState(AppHelper.userCacheGet());
  const [email1, setEmail1] = useState(oUser? (oUser.email1 || ''):'');
  const [email1Sent, setEmail1Sent] = useState(false);
  const [gradeList, setGradeList] = useState([]);
  
  useEffect(()=>{
    if(!open || !profile || !profile.access) return;
    setEmail1Sent(false);
    setEmail1("");
    setGradeList([...profile.access]);
  }, [open, profile]);
  const handleClose = () =>{ onClose() };
  const clickAccess = async(argGrade, argValue)=>{
    const oUser = AppHelper.userCacheGet();
    var _res = await AppHelper.apiPost("api/access/update", {
      token: oUser.token,
      profileId: profile.profileId,
      grade:argGrade.v,
      access:argValue
    });
    if (!_res || !_res.status) {
    }
    var _grades = [...gradeList];
    var _grade = _grades.find(r=>r.v==argGrade.v);
    _grade.a = argValue;
    setGradeList(_grades);
  };

  return(
    <>
    <Dialog onClose={handleClose} open={open}>
      <DialogTitle>ACCESS RIGHTS (QUESTION BANK)</DialogTitle>
      <Box m={1}>
        <Grid container m={1}>
          {gradeList.map((gg, iGG) => (
            <React.Fragment key={'popAccessGrade_'+iGG}>
            <Grid item xs={4} style={{textAlign:'center'}}>
              {gg.v}
            </Grid>
            <Grid item xs={8}>
              <ButtonGroup aria-label="Basic button group" style={{marginTop:'2px'}}>
                <Button
                  variant={gg.a === 0 ? 'contained' : 'outlined'}
                  sx={{
                  backgroundColor: gg.a === 0 ? '#808080' : 'transparent', // Gray for contained
                  color: gg.a === 0 ? '#fff' : 'inherit',                 // White text for gray
                  borderColor: gg.a === 0 ? 'transparent' : 'primary.main', // Border for outlined
                  '&:hover': {
                    backgroundColor: gg.a === 0 ? '#696969' : 'transparent', // Darker gray on hover
                  },
                  }}
                  onClick={() => clickAccess(gg, 0)}
                >
                  NA
				        </Button>

                <Button variant={gg.a==1?'contained':'outlined'} onClick={()=>clickAccess(gg, 1)}>VIEW</Button>
				
                <Button
                  variant={gg.a === 2 ? 'contained' : 'outlined'}
                  sx={{
                  backgroundColor: gg.a === 2 ? 'rgba(19, 130, 117, 1)' : 'transparent', // Teal for contained
                  color: gg.a === 2 ? '#fff' : 'inherit',                // White text for teal
                  borderColor: gg.a === 2 ? 'transparent' : 'primary.main', // Border for outlined
                  '&:hover': {
                    backgroundColor: gg.a === 2 ? '#138275' : 'transparent', // Darker teal on hover
                  },
                  }}
                  onClick={() => clickAccess(gg, 2)}
                >
                  MANAGE
                </Button>
              </ButtonGroup>
            </Grid>
            </React.Fragment>
          ))}
        </Grid>
      </Box>
      { isLoading &&
        <div style={{margin:'1rem', textAlign:'center'}}>
          <CircularProgress />
        </div>
      }
    </Dialog>
    </>
  );
}